import http from "infra/http";
import { EnvURL } from "../enums";

export async function find() {
  const { data } = await http.get(EnvURL.Configurations);

  return data;
}
